import { useEffect, useRef } from "react";
import { ShipmentModel } from "features/shared/shipmentCard.types";
import { usePanelViews } from "features/shared/usePanelViews.hook";
import { isAirSavedCardModel } from "entities/AirSavedCard";
import { appStore } from "entities/App";
import { useAppDispatch, useAppSelector } from "shared/lib/redux";

import { getInitialSearchQPM } from "../ParamsManager";

type UseAirUrlQueryHandlerProps = {
  openedCard: ShipmentModel | null;
};

export const useAirUrlQueryHandler = ({ openedCard }: UseAirUrlQueryHandlerProps) => {
  const dispatch = useAppDispatch();
  const openedCardQPM = useRef(getInitialSearchQPM()).current;
  const requestedFromUrl = useAppSelector(appStore.selectors.requestedFromUrl);
  const { isCurrentViewOpenedCard } = usePanelViews();

  useEffect(() => {
    if (!isCurrentViewOpenedCard) return;
    if (requestedFromUrl || !openedCard?.reference) return;

    openedCardQPM.set("number", openedCard.reference);

    if (isAirSavedCardModel(openedCard) || isAirSavedCardModel(openedCard)) {
      const airline = openedCard?.airlineName;
      if (airline) {
        openedCardQPM.set("airline", airline);
      }
    }

    openedCardQPM.update();
  }, [openedCard?.rawData]);

  useEffect(
    () => () => {
      openedCardQPM.clear();
      openedCardQPM.update();
      dispatch(appStore.actions.setRequestedFromUrl(false));
    },
    []
  );
};
